<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4" v-show="employeeName !== '...'">{{employeeName}}'s Job Histories</h4>
      </div>
      <div class="level-right">
        <router-link :to="{name: 'Edit Employee', params: {employeeId: this.$route.params.employeeId}}" class="button is-small is-info">View&nbsp;<span v-show="employeeName !== '...'">{{employeeName}}'s</span>&nbsp;profile</router-link>
        &nbsp;
        <router-link :to="{name: 'List Of Employees'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
    <hr />
    <div style="clear:both"></div>
    <b-table :data="employeeJobHistories">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" field="effectiveDate" label="Effective date">
          {{item.row.effectiveDate}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="scheduledTimeInAndOut" label="Scheduled time in/out">
          {{item.row.scheduledTimeInAndOut}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="scheduledWorkDays" label="Scheduled workdays">
          {{item.row.scheduledWorkDays}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="monthlySalary" label="Monthly salary">
          {{item.row.monthlySalary}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="isInActive" label="Status">
          <span v-if="item.row.isInActive === false">
            Active
          </span>
          <span v-else>
            Inactive
          </span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="salaryTerm" label="Salary term">
          {{item.row.salaryTerm}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="employeeType" label="Employee type">
          {{item.row.employeeType}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="jobTitle" label="Job title">
          {{item.row.jobTitle}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="reason" label="Reason">
          {{item.row.reason}}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" field="" label="">
          <button class="button is-small is-danger" @click="openDeleteModal(item.row.employeeJobHistoryId)">Delete</button>
        </b-table-column>
      </template>
    </b-table>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Delete job history</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          Are you sure do you want to delete this permanently?
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="buttonDelete" @click="deletePermanently">Yes</button>
          <button class="button is-small" @click="cancel">No</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()
export default {
  data: () => ({
    isLoading: false,
    employeeJobHistories: [],
    employeeName: '...',
    showDeleteModal: false,
    selectedJobHistoryId: 0,
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  created() {
    const employeeId = this.$route.params.employeeId
    if (employeeId) {
      this.getEmployeeJobHistoriesById(employeeId)
    }
  },
  methods: {
    getEmployeeJobHistoriesById(id) {
      this.isLoading = true
      axios
        .get(`api/employees/job-history-by-employee/${id}`)
        .then(response => {
          response.data.forEach(jobHistory => {
            jobHistory.effectiveDate = moment(jobHistory.effectiveDate).format(
              'MM/DD/YYYY'
            )
          })
          this.employeeJobHistories = response.data
          this.employeeName = response.data[0].employeeName
        })
        .catch(error => {
          console.log(error)
          alert('Something went wrong. Failed to fetch info')
        })
        .then(() => {
          this.isLoading = false
        })
    },
    default() {
      this.showDeleteModal = false
      this.selectedJobHistoryId = 0
      this.buttonDelete = appButton.isLoadingDanger(false)
      this.getEmployeeJobHistoriesById(this.$route.params.employeeId)
    },
    openDeleteModal(id) {
      this.showDeleteModal = true
      this.selectedJobHistoryId = id
    },
    cancel(){
      this.default()
    },
    deletePermanently() {
      this.buttonDelete = appButton.isLoadingDanger(true)
      if (this.selectedJobHistoryId) {
        axios
          .delete(
            `api/employees/delete-job-history/${this.selectedJobHistoryId}`
          )
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => appToast.danger(error))
          .then(() => {
            this.default()
          })
      }
    }
  }
}
</script>

